import { render, staticRenderFns } from "./certificazioni.vue?vue&type=template&id=f3e3acc2&"
import script from "./certificazioni.vue?vue&type=script&lang=js&"
export * from "./certificazioni.vue?vue&type=script&lang=js&"
import style0 from "./certificazioni.vue?vue&type=style&index=0&id=f3e3acc2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports